<lib-page-layout>
  <lib-title-navbar pageHeader title="Statystyki Gier"></lib-title-navbar>
  <div class="stats-page">
    @if (stats(); as sd) {
      @if (sd.regionStats.length) {
        <div class="accordion region-totals-accordion" [class.accordion--open]="regionTotalsOpen()">
          <button class="accordion__header" (click)="toggleRegionTotals()">
            <span class="accordion__title">Regiony - łączna liczba gier</span>
            <img
              [src]="regionTotalsOpen() ? 'assets/icons/chevron-up.svg' : 'assets/icons/chevron-down-primary.svg'"
              class="accordion__chevron" />
          </button>
          <div class="accordion__collapse">
            <div class="accordion__body">
              <div class="region-summary">
                @for (region of sd.regionStats; track region.regionName) {
                  <div class="region-summary__item">
                    <span class="region-summary__name">{{ region.regionName }}</span>
                    <span class="region-summary__count">{{ region.gameCount }}</span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    }

    <lib-days-range-slider [value]="statsDays()" (valueChange)="setPeriod($event)"></lib-days-range-slider>

    <div class="view-selector">
      <button
        class="view-btn"
        [class.view-btn--active]="viewMode() === ViewMode.BY_DAY"
        (click)="setViewMode(ViewMode.BY_DAY)">
        Wg dnia
      </button>
      <button
        class="view-btn"
        [class.view-btn--active]="viewMode() === ViewMode.BY_CATEGORY"
        (click)="setViewMode(ViewMode.BY_CATEGORY)">
        Wg typu
      </button>
      <button
        class="view-btn"
        [class.view-btn--active]="viewMode() === ViewMode.BY_REGION"
        (click)="setViewMode(ViewMode.BY_REGION)">
        Wg regionu
      </button>
    </div>

    @if (stats(); as statsData) {
      @if (viewMode() === ViewMode.BY_DAY) {
        <div class="stats-list">
          @for (day of statsData.byDay; track day.rawDate) {
            <div
              class="day-card"
              [class.day-card--clickable]="day.regions.length > 0"
              [class.day-card--expanded]="expandedDay() === day.rawDate"
              (click)="day.regions.length ? toggleDay(day.rawDate) : null">
              <div class="day-card__header">
                <span class="day-card__date">{{ day.date }}</span>
                <span class="day-card__separator">·</span>
                <span class="day-card__day-name">{{ day.dayOfWeek }}</span>
                @if (day.regions.length) {
                  <img
                    [src]="
                      expandedDay() === day.rawDate
                        ? 'assets/icons/chevron-up.svg'
                        : 'assets/icons/chevron-down-primary.svg'
                    "
                    class="day-card__chevron" />
                }
              </div>
              <div class="day-card__stats">
                <div class="stat-item">
                  <span class="stat-item__label">Gierki</span>
                  <span class="stat-item__value">{{ day.gamesCreated }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-item__label">Aplikacje</span>
                  <span class="stat-item__value">{{ day.applicationsCreated }}</span>
                </div>
                <div class="stat-item">
                  <span class="stat-item__label">Akceptacje</span>
                  <span class="stat-item__value">{{ day.applicationsAccepted }}</span>
                </div>
              </div>
            </div>
            @if (expandedDay() === day.rawDate && day.regions.length) {
              <div class="region-daily-breakdown region-daily-breakdown--under-card">
                <div class="region-daily-breakdown__legend">
                  <span class="region-daily-breakdown__legend-item">
                    <span class="region-daily-breakdown__legend-dot"></span> Gierki
                  </span>
                  <span class="region-daily-breakdown__legend-item">
                    <span
                      class="region-daily-breakdown__legend-dot region-daily-breakdown__legend-dot--secondary"></span>
                    Aplikacje
                  </span>
                  <span class="region-daily-breakdown__legend-item">
                    <span
                      class="region-daily-breakdown__legend-dot region-daily-breakdown__legend-dot--secondary"></span>
                    Akceptacje
                  </span>
                </div>
                @for (region of day.regions; track region.regionName) {
                  <div class="region-daily-breakdown__row">
                    <div class="region-daily-breakdown__date">
                      <span>{{ region.regionName }}</span>
                    </div>
                    <div class="region-daily-breakdown__stats">
                      <span class="region-daily-breakdown__stat" title="Gierki">{{ region.gamesCreated }}</span>
                      <span
                        class="region-daily-breakdown__stat region-daily-breakdown__stat--secondary"
                        title="Aplikacje"
                        >{{ region.applicationsCreated }}</span
                      >
                      <span
                        class="region-daily-breakdown__stat region-daily-breakdown__stat--secondary"
                        title="Akceptacje"
                        >{{ region.applicationsAccepted }}</span
                      >
                    </div>
                  </div>
                }
              </div>
            }
          } @empty {
            <div class="stats-empty">Brak danych</div>
          }
        </div>
      } @else if (viewMode() === ViewMode.BY_CATEGORY) {
        <div class="stats-list">
          @for (category of statsData.byCategory; track category.label) {
            <div class="accordion" [class.accordion--open]="isCategoryOpen(category.label)">
              <button class="accordion__header" (click)="toggleCategory(category.label)">
                <span class="accordion__title">{{ category.label }}</span>
                <div class="accordion__right">
                  <span class="accordion__total">{{ category.total }}</span>
                  <img
                    [src]="
                      isCategoryOpen(category.label)
                        ? 'assets/icons/chevron-up.svg'
                        : 'assets/icons/chevron-down-primary.svg'
                    "
                    class="accordion__chevron" />
                </div>
              </button>
              <div class="accordion__collapse">
                <div class="accordion__body">
                  @for (item of category.items; track item.rawDate) {
                    <div
                      class="category-row"
                      [class.category-row--clickable]="item.regions.length > 0"
                      [class.category-row--expanded]="expandedCategoryItem() === category.label + ':' + item.rawDate"
                      (click)="item.regions.length ? toggleCategoryItem(category.label + ':' + item.rawDate) : null">
                      <div class="category-row__date">
                        <span>{{ item.date }}</span>
                        <span class="category-row__day">{{ item.dayOfWeek }}</span>
                      </div>
                      <div class="category-row__right">
                        <span class="category-row__count">{{ item.count }}</span>
                        @if (item.regions.length) {
                          <img
                            [src]="
                              expandedCategoryItem() === category.label + ':' + item.rawDate
                                ? 'assets/icons/chevron-up.svg'
                                : 'assets/icons/chevron-down-primary.svg'
                            "
                            class="category-row__chevron" />
                        }
                      </div>
                    </div>
                    @if (expandedCategoryItem() === category.label + ':' + item.rawDate && item.regions.length) {
                      <div class="category-region-breakdown">
                        @for (region of item.regions; track region.regionName) {
                          <div class="category-region-breakdown__item">
                            <span class="category-region-breakdown__name">{{ region.regionName }}</span>
                            <span class="category-region-breakdown__count">{{ region.count }}</span>
                          </div>
                        }
                      </div>
                    }
                  } @empty {
                    <div class="stats-empty">Brak danych</div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="stats-list">
          @for (region of statsData.byRegion; track region.regionName) {
            <div
              class="region-item region-item--clickable"
              [class.region-item--expanded]="expandedRegion() === region.regionName"
              (click)="toggleRegion(region.regionName)">
              <div class="region-item__name">{{ region.regionName }}</div>
              <div class="region-item__right">
                <span class="region-item__count">{{ region.totalGames }}</span>
                <span class="region-item__count region-item__count--secondary">{{ region.totalApplications }}</span>
                <span class="region-item__count region-item__count--secondary">{{ region.totalAccepted }}</span>
                <img
                  [src]="
                    expandedRegion() === region.regionName
                      ? 'assets/icons/chevron-up.svg'
                      : 'assets/icons/chevron-down-primary.svg'
                  "
                  class="region-item__chevron" />
              </div>
            </div>
            @if (expandedRegion() === region.regionName) {
              <div class="region-daily-breakdown">
                <div class="region-daily-breakdown__legend">
                  <span class="region-daily-breakdown__legend-item">
                    <span class="region-daily-breakdown__legend-dot"></span> Gierki
                    <span class="region-daily-breakdown__legend-value">{{ region.totalGames }}</span>
                  </span>
                  <span class="region-daily-breakdown__legend-item">
                    <span
                      class="region-daily-breakdown__legend-dot region-daily-breakdown__legend-dot--secondary"></span>
                    Aplikacje
                    <span
                      class="region-daily-breakdown__legend-value region-daily-breakdown__legend-value--secondary"
                      >{{ region.totalApplications }}</span
                    >
                  </span>
                  <span class="region-daily-breakdown__legend-item">
                    <span
                      class="region-daily-breakdown__legend-dot region-daily-breakdown__legend-dot--secondary"></span>
                    Akceptacje
                    <span
                      class="region-daily-breakdown__legend-value region-daily-breakdown__legend-value--secondary"
                      >{{ region.totalAccepted }}</span
                    >
                  </span>
                </div>
                @for (day of region.dailyStats; track day.date) {
                  <div class="region-daily-breakdown__row">
                    <div class="region-daily-breakdown__date">
                      <span>{{ day.date }}</span>
                      <span class="region-daily-breakdown__day">{{ day.dayOfWeek }}</span>
                    </div>
                    <div class="region-daily-breakdown__stats">
                      <span class="region-daily-breakdown__stat" title="Gierki">{{ day.gamesCreated }}</span>
                      <span
                        class="region-daily-breakdown__stat region-daily-breakdown__stat--secondary"
                        title="Aplikacje"
                        >{{ day.applicationsCreated }}</span
                      >
                      <span
                        class="region-daily-breakdown__stat region-daily-breakdown__stat--secondary"
                        title="Akceptacje"
                        >{{ day.applicationsAccepted }}</span
                      >
                    </div>
                  </div>
                }
              </div>
            }
          } @empty {
            <div class="stats-empty">Brak danych</div>
          }
        </div>
      }
    }
  </div>
</lib-page-layout>
